export const errorMessages = {
 emptyDashboard : 'Click "+" Icon to Add Widget',
 noWidgetData : 'No data available !',
 apiError: 'Application service encountered some issue, Please contact the administrator!'
};


// WEBPACK FOOTER //
// ./src/app/settings/errorMessages.ts